export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-thumbnail-480-22f4678bfe989bfe7b26d960f25313e5.png";